import { useState, useEffect } from "react";
import dayjs from "dayjs";
import {
  cleanFilterData,
  buildQueryParams,
} from "../../../../../Utils/FilterUtils";
import httpclient from "../../../../../Utils";

export const usePickerReport = ({ autoFetch = true, filters = {} } = {}) => {
  const [reportData, setReportData] = useState([]);
  const [pickers, setPickers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fieldMappings = {
    picker_id: ["picker_id"],
    category_id: ["category_id"],
    start_date: ["start_date"],
    end_date: ["end_date"],
    page: ["page"],
    pagination: ["pagination"],
  };

  const valueTransformers = {
    start_date: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : ""),
    end_date: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : ""),
  };

  const fetchReportData = async (filterData = {}) => {
    setLoading(true);
    setError(null);

    const dataWithPagination = { ...filterData, page: 1, pagination: 50 };
    const cleanedData = cleanFilterData(dataWithPagination);
    const queryParams = buildQueryParams(
      cleanedData,
      fieldMappings,
      {},
      valueTransformers
    );
    const url = `/reports/picker-report${queryParams ? `?${queryParams}` : ""}`;

    try {
      const response = await httpclient.get(url);
      if (response.data.status === 200) {
        setReportData(response.data.data || []);
        setPickers(response.data.pickers || []);
        setCategories(response.data.categories || []);
      } else {
        setError(response.data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchReportData();
    }
  }, [autoFetch]);

  return {
    reportData,
    pickers,
    categories,
    loading,
    error,
    fetchReportData,
  };
};
